<template>
  <div class="page-content">
    <div class="log-container">
        <div class="log-content-one">
            <div class="content-one-container">
                <div class="content-one-wrap">
                    <img class="logo_pic" src="../../assets/images/login/branner_v3.png">
    						<span class="nav-line">
    						</span>
    						<span class="nav-text-left">
    							需求方平台
    						</span>
    						<span class="nav-text-right">
    						</span>
                </div>
                <div class="content-one-left">
                    <div class="content-one-textback" style="background-image: url(&quot;https://xmtransfer.suporpe.com/media/home_v2.png?v=0104?rom=1593693450820&quot;);">
                    </div>
                    <div class="one-left-frame">
                        <div>
                            <p>
                                您想要的用户都在这里
                            </p>
                            <p>
                                赶快注册账号向您的目标用户推广吧
                            </p>
                        </div>
                    </div>
                    <div class="one-left-bottom" style="display: block;">
                        <div class="one-bottom-text">
                            今日广告累计曝光量：
                        </div>
                        <ul>
                            <li class="back" :style="'background-image: url(' + getBg(item) + ');'" v-for="(item, index) in pics" :key="index"></li>
                        </ul>
                        <div class="one-bottom-textlast">
                            次
                        </div>
                    </div>
                </div>
                <div class="content-one-right">
                    <div class="one-right-container">
                        <div class="one-right-title">
                            平台登录
                        </div>
                        <div class="one-right-input">
                            <el-input id="phone" @keypress.native.enter="login" type="text" v-model="username" placeholder="请输入手机号或邮箱号" name="phone"></el-input>
                        </div>
                        <div class="one-right-input">
                            <el-input id="passWord" @keypress.native.enter="login" type="password" v-model="password" placeholder="请输入用户密码" name="password" maxlength="18"></el-input>
                        </div>
                        <div class="one-right-inputnum" style="display: flex;">
                            <el-input id="code" @keypress.native.enter="login" type="text" placeholder="验证码" name="code" maxlength="4" v-model="code" style="width: 140px;"></el-input>
                            <verify-code :identifyCode="verify_code" @getCode="getCode()" style="margin-left: 10px;"></verify-code>
                            <div class="empty"></div>
                        </div>
                        <div class="errMsg" v-text="emptyText">
                        </div>
                        <div class="test-container">
                            <div class="btn-bg test-btn">
                              <span id="login" @click="login">登录</span>
                            </div>
                        </div>
                        <div class="one-right-bottom">
                            <div class="register">
                                <a href="http://e.ssp.eastdaymedia.com.cn/register.html?v=2">
                                    免费注册
                                </a>
                            </div>
                            <div class="forget-password">
                                <a href="http://e.ssp.eastdaymedia.com.cn/forgetpwd.html?v=2">
                                    忘记密码
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="log-content-two">
            <div class="content-two-container">
                <p class="two-container-title">
                    基于多场景的用户画像，使您的广告定向更精准
                </p>
                <p class="two-container-text">
                    我们为您提供了众多广告定向条件，您可以从中选择适合达成您商业目标的条件锁定人群。
                </p>
                <p class="two-container-text">
                    这些条件包括年龄、商业兴趣、地理位置、使用设备、网络环境等等。
                </p>
                <div class="two-container-body">
                    <div class="two-container-message">
                      <img src="../../assets/images/login/home-characterA.png" alt="">
                      <p>用户A，白领，男，年龄：30周岁</p>
                      <p>喜欢汽车类资讯</p>
                    </div>
                    <div class="two-container-message container-message-middle">
                      <img src="../../assets/images/login/home-characterB.png" alt="">
                      <p>用户B，学生，女，年龄：19周岁</p>
                      <p>喜欢时尚、服饰类资讯</p>
                    </div>
                    <div class="two-container-message">
                      <img src="../../assets/images/login/home-characterC.png" alt="">
                      <p>用户C，公务员，男，年龄：40周岁</p>
                      <p>喜欢养生、保健类资讯</p>
                    </div>
                </div>
                <div class="test-container">
                    <div class="btn-bg test-btn">
                      <span>
                        <a href="http://e.ssp.eastdaymedia.com.cn/register.html?v=1">免费注册</a>
                      </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="log-content-three">
            <div class="content-three-container">
                <p class="three-container-title">
                    丰富的广告样式，供您选择
                </p>
                <p class="three-container-text">
                    大图、单图、三图等主流信息流广告样式，
                </p>
                <p class="three-container-text">
                    让您的素材与新闻融为一体，从而获得更好的转化
                </p>
                <div class="three-container-body">
                    <div class="three-body-view">
                        <img src="../../assets/images/login/home-threepic.png" alt="">
                        <p>
                            三图模式
                        </p>
                    </div>
                    <div class="three-body-view">
                        <img src="../../assets/images/login/home-bigpic.png" alt="">
                        <p>
                            大图模式
                        </p>
                    </div>
                    <div class="three-body-view">
                        <img src="../../assets/images/login/home-messagead.png" alt="">
                        <p>
                            信息流广告
                        </p>
                    </div>
                    <div class="three-body-view three-view-single">
                        <img src="../../assets/images/login/home-singlepic.png" alt="">
                        <p>
                            单图模式
                        </p>
                    </div>
                </div>
                <div class="test-container">
                    <div class="btn-bg test-btn">
    							<span>
    								<a href="http://e.ssp.eastdaymedia.com.cn/register.html?v=1">免费注册</a>
    							</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="log-content-four">
            <div class="content-four-container">
                <p class="four-container-title">
                    优质的私有媒体流量，全部对您开放
                </p>
                <p class="four-container-text">
                    流量覆盖PC、wap、APP端，丰富优质的资源全部对您开放
                </p>
                <div class="four-container-body">
                    <div class="four-body-view">
                        <img src="../../assets/images/login/icon-dongfangtoutiao.png" alt="">
                        <p>
                            东方头条
                        </p>
                    </div>
                    <div class="four-body-view">
                        <img src="../../assets/images/login/6.png" alt="">
                        <p>
                            东方网
                        </p>
                    </div>
                    <div class="four-body-view">
                        <img src="../../assets/images/login/icon-weather.png" alt="">
                        <p>
                            天气预报
                        </p>
                    </div>
                    <div class="four-body-view">
                        <img src="../../assets/images/login/icon-maopu.png" alt="">
                        <p>
                            猫扑
                        </p>
                    </div>
                    <div class="four-body-view">
                        <img src="../../assets/images/login/icon-maopucar.png" alt="">
                        <p>
                            猫扑汽车
                        </p>
                    </div>
                    <div class="four-body-view four-body-single">
                        <img src="../../assets/images/login/4.png" alt="">
                        <p>
                            东方新闻
                        </p>
                    </div>
                </div>
                <div class="partnerArea">
                    <div class="partnerArea_title">
                        欢迎更多合作伙伴与我们共创未来
                    </div>
                    <div class="partnerArea_inputArea">
                        <input type="text" placeholder="输入合作伙伴关键词检索">
                        <div class="test-container">
                            <div class="btn-bg test-btn">
                                检索
                            </div>
                        </div>
                    </div>
                    <div class="test-container">
                        <div class="btn-bg test-btn">
                    <span>
                      <a href="http://e.ssp.eastdaymedia.com.cn/register.html?v=1">加入我们</a>
                    </span>
                      </div>
                    </div>
                    <div class="partnerArea_result">
                        <p>
                            查找结果
                        </p>
                        <ul>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="log-footer">
            <div class="log-footer-content">
                <p>
                    COPYRIGHT © 2019 东方网(上海)传媒有限公司 沪ICP备16033182号-2
                </p>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  /* global require */
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      code: '',
      verify_code: '',
      pics: '',
      emptyText: '',
      trmorrw: ''
    };
  },
  created() {
    if (sessionStorage.getItem('token')) {
      this.$router.push({ path: '/' });
    }
    this.getCode();
    this.setTime();
  },
  beforeCreate() {
    if (this.$route.query.token) {
      this.$http.post('/trader/login/login', {
        token: this.$route.query.token
      }).then(res => {
        if (res.code === 200) {
          window.location.href = this.$Config.apiUrl;
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    setTime() {
      const day3 = new Date();
      day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000);
      this.trmorrw = day3.getFullYear() + '/' + (day3.getMonth() + 1) + '/' + day3.getDate() + ' 00:00:00';
      this.resetTime();
    },
    resetTime() {
      const end_time = new Date(this.trmorrw).getTime();
      const now_time = new Date().getTime();
      this.pics = (((86400 - parseInt((end_time - now_time) / 1000))) * 6425) + '';
      setTimeout(this.resetTime, 1000);
    },
    getCode() {
      const str = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKMNOPQRSTUVWXYZ';
      const codes = str.split('');
      const arr = [];
      for (let i = 0; i < 4; i++) { // 从0-61之间取随机数
        const index = Math.floor(Math.random() * (58 - 0 + 1) + 0);
        const char = codes[index];
        arr.push(char);
      }
      this.verify_code = arr.join('');
    },
    getBg(index) {
      return this.$Config.apiUrl + '/static/images/' + index + '.png';
    },
    login() {
      if (this.username === '') {
        this.emptyText = '用户名不能为空';
        return false;
      }
      if (this.password === '') {
        this.emptyText = '密码不能为空';
        return false;
      }
      if (this.code === '') {
        this.emptyText = '验证码不能为空';
        return false;
      }
      if (this.code.toLowerCase() !== this.verify_code.toLowerCase()) {
        this.emptyText = '验证码有误';
        this.getCode();
        return false;
      }
      this.$http.post('/trader/login/doLogin', {
        username: this.username,
        password: this.password
      })
        .then(res => {
          if (res.code === 200) {
            this.$router.push({ path: '/' });
          } else {
            this.$message.error(res.msg);
          }
        });
    }
  },
  components: { VerifyCode: resolve => require(['./Components/VerifyCode.vue'], resolve) },
  watch: {
    username() {
      this.emptyText = '';
    },
    password() {
      this.emptyText = '';
    },
    codeA() {
      this.emptyText = '';
    }
  }
};
</script>
<style>
  @import '../../assets/css/login.css';

</style>
